module.exports = __webpack_public_path__ + "static/img/envelope02khm.d2ed45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope02khm.png
// module id = +NWg
// module chunks = 1